import ajax from "../helpers/ajax";
import { ReferralResult, Referral } from "../types";
import StoreContainer from "../stores/StoreContainer";
import * as $ from "jquery";

class ReferralService {
  static async shouldShowReferrralContentInFrame() {
    return await this.shouldShowReferral(
      StoreContainer.SettingStore.getSiteId(),
      false
    );
  }
  static async openReferralWindow() {
    if (
      await this.shouldShowReferral(
        StoreContainer.SettingStore.getSiteId(),
        true
      )
    ) {
      window.open(
        this.buildReferralUrl(),
        "_blank",
        this.buildReferralOptions()
      );
    }
  }

  static async getReferral(): Promise<Referral> {
    return (await ajax({
      url: `${this.buildReferraRetrievallUrl()}`
    })) as Referral;
  }

  static buildReferralOptions(): string {
    var options = "toolbar=no,menubar=no,location=no,resizable=yes";

    var width = StoreContainer.SettingStore.getReferralWindowWidth();
    var height = StoreContainer.SettingStore.getReferralWindowHeight();
    if (width) {
      options += `,width=${width}`;
    }
    if (height) {
      options += `,height=${height}`;
    }

    return options;
  }
  static async shouldShowReferral(
    siteId: number,
    forNewWindow: boolean
  ): Promise<boolean> {
    if (StoreContainer.SettingStore.getShowReferral() == false) {
      return false;
    }

    if (forNewWindow === StoreContainer.SettingStore.getShowReferralInFrame()) {
      return false;
    }

    if (StoreContainer.SettingStore.getShowReferralConditionally() == false) {
      return true;
    }

    var result = (await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/referral`,
      data: StoreContainer.VisitorStore.getExpressionRequestModel(),
      method: "post"
    })) as ReferralResult;

    if (!result.ShowReferral) {
      return false;
    }

    if (result.TimeOnPageRule) {
      var expression = result.TimeOnPageRule.replace(
        "{Page.Time}",
        StoreContainer.InviteStore.getSecondsOnPage().toString()
      );
      return eval(expression);
    }

    return true;
  }

  static buildReferralUrl() {
    var url = `${StoreContainer.SettingStore.getConsoleEndpoint()}/referral`;

    var params: any = {
      siteId: StoreContainer.SettingStore.getSiteId()
    };

    var groupId = StoreContainer.GroupStore.getActiveOrPageGroupId();
    if (groupId) {
      params.groupId = groupId;
    }

    return `${url}?${$.param(params)}`;
  }

  static buildReferraRetrievallUrl() {
    var url = `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${StoreContainer.SettingStore.getSiteId()}/referral/retrieve`;
    var groupId = StoreContainer.GroupStore.getActiveOrPageGroupId();

    var params: any = {
      groupId: groupId || 0
    };
    return `${url}?${$.param(params)}`;
  }
}

export default ReferralService;
